// extracted by mini-css-extract-plugin
export default {"innerWrapper":"As-z","tooltipWrapper":"Bs-z","icon":"Cs-z","tooltip":"Ds-z","content":"Es-z"};